module.exports = __webpack_public_path__ + "img/footer-image.f962094e.png";